import anime from "animejs";
import {getOptionsFromJsonString} from "../../../../default/global/js/utilities/options";

export function initScrollbars(query = document.querySelectorAll('.js-scrollbar')) {
    query.forEach((container) => {
        const track = container.querySelector('[data-track]');
        const parentDiv = container.parentElement;
        const isBrandScrollbar = parentDiv.classList.contains('scrollbarBrands');
        const isGalleryScrollbar = parentDiv.classList.contains('scrollbarGallery');
        const isMarquee = parentDiv.querySelector('.trustBar--marquee');
        let animation;
        let options = getOptionsFromJsonString(container.dataset.options, {
            autoplay_interval: 50,
            eff_interval: 50,
            pause_on_hover: isBrandScrollbar || isMarquee,
            scrollbar_at_mobile: isBrandScrollbar,
            scrollbar_below_mobile: false,
            init_on_overflow: false,
        });

        const getWidth = (element) => element.offsetWidth;

        const updateContent = () => {
            const content = track.firstElementChild;
            if (!content) return;
            const contentWidth = getWidth(content);
            const containerWidth = getWidth(container);
            const parentDivWidth = getWidth(parentDiv);
            if (!contentWidth || !containerWidth) return;

            if (options.init_on_overflow && contentWidth < parentDivWidth) {
                stopAnimation();
                removeExtraClones();
                return;
            }
            if (options.scrollbar_below_mobile && window.innerWidth > 768) {
                stopAnimation(); // Stop animation if screen width is > 768px
                removeExtraClones();
                return;
            }

            if (options.scrollbar_at_mobile && window.innerWidth <= 768) {
                stopAnimation(); // Stop animation if screen width is ≤ 768px
                removeExtraClones();
                return;
            }


            let requiredRepeats = Math.ceil(containerWidth / contentWidth) + 1;
            if (contentWidth * 2 > window.innerWidth) {
                requiredRepeats = 2;
            }
            updateAnimation(containerWidth);
            while (track.children.length < requiredRepeats) {
                const clone = content.cloneNode(true);
                clone.setAttribute("aria-hidden", "true");
                const links = clone.querySelectorAll('a');
                links.forEach(link => {
                    link.setAttribute('tabindex', '-1');
                    link.setAttribute('aria-disabled', 'true');
                });
                track.appendChild(clone);
            }
        };

        const updateAnimation = (containerWidth) => {
            const duration = (containerWidth / options.eff_interval) * 1000;
            if (animation) {
                animation.duration = duration;
                animation.play();
            } else {
                animation = anime({
                    targets: track,
                    translateX: '-50%',
                    duration,
                    easing: 'linear',
                    loop: true,
                    autoplay: true,
                    round: 1000
                });
            }
        };

        const stopAnimation = () => {
            if (animation) {
                animation.pause();
                animation.seek(0);
                animation = null;
            }
        };

        const removeExtraClones = () => {
            const children = [...track.children];
            if (children.length > 1) {
                children.slice(1).forEach((child) => track.removeChild(child));
            }
        };

        if (options.pause_on_hover) {
            container.addEventListener('mouseenter', () => animation?.pause());
            container.addEventListener('mouseleave', () => animation?.play());
        }

        const handleResize = () => {
            updateContent();
        };
        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                handleResize();
            }
        });

        resizeObserver.observe(container);
        window.addEventListener('resize', handleResize);
        updateContent(); // Initial setup
    });
}
